/**
 * Set the height of the language switcher dropdown.
 */
export const setLanguageSwitchersHeight = () => {

	document.querySelectorAll( '.c-lang-switcher' ).forEach( switcher => {

		const wrapper = switcher.querySelector( '.c-lang-switcher__wrapper' );

		if ( !wrapper ) {

			return;

		}

		switcher.style.setProperty( '--lang-list-total-height', `${wrapper.scrollHeight}px` );

	} );

};
